import { CartType, CommonStatus } from 'models/common'
import { LogisticCartUrgency } from 'models/logistic_cart'

export const COMMON_STATUS_TEXT: Record<CommonStatus, string> = {
  [CommonStatus.in_process]: 'В очереди',
  [CommonStatus.waiting]: 'В работе',
  [CommonStatus.error]: 'На уточнении',
  [CommonStatus.consideration]: 'На рассмотрении',
  [CommonStatus.delivered]: 'Доставлен',
  [CommonStatus.denied]: 'Отклонено',
  [CommonStatus.given]: 'Закрыто',
  [CommonStatus.notfound]: 'Не найден',
  [CommonStatus.awaiting]: 'На подтверждении',
}

export const CART_TYPES: Record<CartType, string> = {
  [CartType.visa]: 'Visa',
  [CartType.elcart]: 'Элкарт',
}

export const URGENCY_TYPES: Record<LogisticCartUrgency, string> = {
  [LogisticCartUrgency.high]: 'Высокая',
  [LogisticCartUrgency.medium]: 'Средняя',
}
